import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes, rgba } from '@similarweb/styles';

import { Button } from '../../../../components/Button';
import { Dropdown } from '../../../../components/Dropdown';

export const StyledButton = styled(Button)`
  width: '100%';
  justify-content: 'flex-start';
  align-items: center;
  border-radius: 6px;
  color: ${colorsPalettes.carbon[400]};
  display: flex;
  background-color: ${rgba(colorsPalettes.carbon[25], 0.95)};
  padding: 8px;
`;

export const StyledDropdown = styled(Dropdown)`
  padding: 12px 8px;
  overflow: visible;
  width: 230px;
  border-radius: 6px;
`;

export const StyledHistorycalDataIconContainer = styled.div`
  position: relative;
`;

export const StyledArrowIcon = styled(SWReactIcons)<{ isOpen: boolean }>`
  transform: ${({ isOpen }) => `rotate(${isOpen ? 180 : 0}deg)}`};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledTextContainer = styled.div`
  margin-right: 12px;
  margin-left: 4px;
  font-weight: 500;
  color: ${colorsPalettes.carbon[400]};
`;
